import { Drawer } from 'components/Drawer'
import { observer } from 'mobx-react-lite'
import { DrawerProps } from 'components/Drawer/Root'
import { QuestionnairePanel, StepId, STEPS } from 'components/GenerationStatus/QuestionnairePanel'
import { useCallback, useState } from 'react'
import { ArrowLeft } from 'blaze-ui/icons'
import { StepsHeader } from './StepsHeader'
import { Text } from 'blaze-ui/Text/Text'
import { useRootStore } from 'stores/RootStore'

export const QUESTIONNAIRE_SNAP_POINT = '120px'

interface QuestionnaireDrawerProps extends DrawerProps {
  initialSnapPoint?: string | number
  onComplete?: () => void
}

export const QuestionnaireDrawer = observer(
  ({ initialSnapPoint = 1, onComplete, ...props }: QuestionnaireDrawerProps) => {
    const { drawersStore } = useRootStore()
    const [currentSnapPoint, setCurrentSnapPoint] = useState<string | number | null>(initialSnapPoint)
    const [currentStep, setCurrentStep] = useState(0)

    const hiddenSteps = [StepId.MarketingDocs, StepId.GoogleDrive, StepId.SocialAccounts]
    const totalSteps = STEPS.length - hiddenSteps.length

    const goBack = useCallback(() => {
      setCurrentStep((i) => Math.max(0, i - 1))
    }, [setCurrentStep])

    return (
      <Drawer.Root
        {...props}
        open
        dismissible={false}
        modal={false}
        snapPoints={[QUESTIONNAIRE_SNAP_POINT, 1]}
        activeSnapPoint={currentSnapPoint}
        setActiveSnapPoint={setCurrentSnapPoint}
      >
        <Drawer.Portal>
          <Drawer.Overlay withBlur={false} />
          <Drawer.Content>
            <Drawer.InnerContent>
              <Drawer.Top>
                {currentStep > 0 && currentSnapPoint === 1 ? (
                  <Drawer.Back position="left" onPress={goBack}>
                    <ArrowLeft size={24} />
                  </Drawer.Back>
                ) : (
                  <div />
                )}
                <div style={{ height: '46px', display: 'flex', alignItems: 'center' }}>
                  <Drawer.Title asChild>
                    <Text variant="secondary">
                      {currentSnapPoint === QUESTIONNAIRE_SNAP_POINT ? 'Show' : 'Hide'} Questionnaire
                    </Text>
                  </Drawer.Title>
                </div>
                <div />
                <StepsHeader currentStep={currentStep} totalSteps={totalSteps} />
              </Drawer.Top>
              <Drawer.Container>
                <QuestionnairePanel
                  hintAsPlaceholder
                  subtitle="While you wait for your content to generate..."
                  brandMediaSubtitle="Add source material for future generations."
                  overrideStep={currentStep}
                  onStepChange={setCurrentStep}
                  hiddenSteps={hiddenSteps}
                  variant="onboarding"
                  onFinish={() => {
                    onComplete?.()
                    drawersStore.closeDrawer()
                  }}
                />
              </Drawer.Container>
            </Drawer.InnerContent>
          </Drawer.Content>
          <Drawer.Overlay />
        </Drawer.Portal>
      </Drawer.Root>
    )
  },
)
